import React from 'react';
import './_header.scss';
import { useBranding } from '../../contexts/BrandingContext';

const Header = () => {
  // Branding Data
  const { branding } = useBranding();
  return (
    <>
      <div className="header-container">
        <div className="logo">
          <img src={branding.logoPath} className="logo-img" width="42" alt={branding.appTitle} />
        </div>
        {/* <div className="title">{branding.appTitle}</div> */}
      </div>
    </>
  );
};

export default Header;
